import { ParameterSchema } from '@taquito/michelson-encoder';
import { ContractAbstraction, TransferParams, Wallet } from '@taquito/taquito';

export type EntrypointSendOptions = {
    amount?: number;
    mutez?: boolean;
    storageLimit?: number;
};

export function entrypointTransferParams(
    contract: ContractAbstraction<Wallet>,
    entrypoint: string,
    args: unknown[],
    options: EntrypointSendOptions = {}
): TransferParams {
    const schema = new ParameterSchema(contract.entrypoints.entrypoints[entrypoint]);
    return {
        to: contract.address,
        amount: options.amount ?? 0,
        mutez: options.mutez ?? false,
        storageLimit: options.storageLimit,
        parameter: { entrypoint, value: schema.Encode(...args) },
    };
}
